export default {
    school: {
        info: "基本信息",
        record: "查看歷年繳付年度費記錄",
        record_title: "歷年繳付年度費記錄",
        companyIdentityType: "商業登記類型",
        companyBrNo: "商業登記編號",
        licenseNo: "學校執照編號",
        licenseNo_coach: "駕駛教練員准照編號",
        licenseNo_headmaster: "駕駛學校校長准照編號",
        lastIssueDate: "駕駛學校執照最後簽發日期",
        lastIssueDate_coach_headmaster: "准照簽發日期",
        schoolName: "學校名稱",
        infoTips: '上述資料如有不符，請到交通事務局服務專區辦理資料更新。',
        payment_info: "繳費信息",
        payment_name: "繳付項目描述",
        amount: "年度費用",
        taxAmount: "印花稅（申請費用的 10%）",
        notice: "繳費通知",
        payment_notice: "(付款後將透過此電郵收到確認繳費通知)",
        payment_btn: "立即繳付",
        email: '電子郵件（可選）：',
        email_required: '電子郵件：',
        email_plh: '請輸入電子郵件',
        email_again_plh: '請再次輸入電子郵件',
        taxYear: "年度",
        spNo: "個案查詢編號",
        totalAmount: "繳付總額",
        paymentType: "繳付方式",
        paymentTime: "繳付日期",
        surname: '姓',
        name: '名',
        nextTrainYear: "再培訓年份",
        schoolName_name: "駕駛學校",
        lastUpdDate: "服務日期",
        CO: "自然人商業企業主(CO)",
        EM: "商業企業(EM)",
        SO: "法人商業企業主(SO)",
        ES: "駕駛學校(ES)",
        mobile_sms: "本澳流動電話(本局將於服務辦理完成後發送短訊通知)",
        school_identType: "駕駛學校的商業登記類型",
        school_identType_plc: "請選擇駕駛學校的商業登記類型",
        school_identNo: "駕駛學校的商業登記編號",
        school_choose: "請選擇任一身份進行業務辦理",
        school_identNo_plh: "請輸入駕駛學校的商業登記編號",
        school_licenseNo: "駕駛學校的執照編號",
        school_licenseNo_plh: "請輸入駕駛學校的執照編號",
        sendSms_tips: "同意將完成支付之短訊同時發送予准照持有人 (流動電話：{0})",
        terms_body_school: "<p>" +
            "  1. 使用說明" +
            "  <br />" +
            "</p>" +
            "<ul class='terms-ul-inline'>" +
            "  <li><span>1.1</span><span style='flex:1'>本系統使用澳門元結算；</span></li>" +
            "  <li><span>1.2</span><span style='flex:1'>當網上交易完成後，所繳交的款項將不獲退回；</span></li>" +
            "  <li><span>1.3</span><span style='flex:1'>如遇上系統故障或其他特別情況而引致閣下繳付了不應由本地區政府收取的款項，請盡快聯絡或親臨本局查詢。</span></li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  2. 個人資料的保護" +
            "  <br />" +
            "</p>" +
            "<ul class='terms-ul-inline'>" +
            "  <li><span>2.1</span><span style='flex:1'>作為本網站的擁有者，本局保證本局工作人員均遵守所有的相關規定，你的個人資料處理會受到保密措施規範，並得到妥為保存。個人資料會保存直至該等資料無須再用於收集時所作的用途，或到政府規定的保存期限，屆時這些資料將按有關規定銷毀；</span></li>" +
            "  <li><span>2.2</span><span style='flex:1'>你有權向本局查閱及修改保存於本網站上的你的個人資料，或向接收本局之轉交並保存這些資料的其他政府部門查閱及修改保存於該局網站上的你的個人資料。</span></li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  3. 免責聲明" +
            "  <br />" +
            "</p>" +
            "<ul class='terms-ul-inline'>" +
            "  <li><span>3.1</span><span style='flex:1'>本網站已盡力確保內容準確，但並不對該等內容作出任何明示或隱含的保證及承諾，所有資料以「現狀」提供，不負任何責任。交通事務局也保留權利隨時刪除、暫時停載或編輯本網址上的各項資料而無須事先通知。交通事務局不對因為使用網站的資料而引致的任何損害或損失負任何責任或作任何賠償。</span></li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  4. 私隱條款" +
            "  <br />" +
            "</p>" +
            "<ul class='terms-ul-inline'>" +
            "  <li><span>4.1</span><span style='flex:1'>繳費者於本系統所輸入之個人資料只會用於本系統及列印在電子收據上；</span></li>" +
            "  <li><span>4.2</span><span style='flex:1'>為使使用者於本網頁所輸入的資料保密，本服務使用加密套接協議層(SSL)。</span></li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  5. 若本使用條款有任何更新，我們會用新版本取代舊版本發佈，並在文件中列明更新修訂日期，但不作另行公佈。" +
            "  <br />" +
            "</p>" +
            "<p></p>" +
            "<p>" +
            "  6. 聯絡方法" +
            "  <br />" +
            "</p>" +
            "<ul class='terms-ul-inline'>" +
            "  <li>地址：澳門馬交石炮台馬路33號地下 交通事務局（馬交石）服務專區</li>" +
            "  <li>辦公時間：星期一至星期五上午9時至下午6時(中午照常辦公)</li>" +
            "  <li>交通事務專線：(853) 8866 6363</li>" +
            "  <li>電郵：info@dsat.gov.mo</li>" +
            "</ul>",
        terms_body_staff: "<p>" +
            "  1. 注意事項" +
            "  <br />" +
            "</p>" +
            "<ul class='terms-ul-inline'>" +
            "  <li><span>1.1</span><span style='flex:1'>未持有新式樣准照的人士不能使用本服務；</span></li>" +
            "  <li><span>1.2</span><span style='flex:1'>未按期報讀再培訓課程的人士不能使用本服務。</span></li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  2. 使用說明" +
            "  <br />" +
            "</p>" +
            "<ul class='terms-ul-inline'>" +
            "  <li><span>2.1</span><span style='flex:1'>本系統使用澳門元結算；</span></li>" +
            "  <li><span>2.2</span><span style='flex:1'>當網上交易完成後，所繳交的款項將不獲退回；</span></li>" +
            "  <li><span>2.3</span><span style='flex:1'>如遇上系統故障或其他特別情況而引致閣下繳付了不應由本地區政府收取的款項，請盡快聯絡或親臨本局查詢。</span></li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  3. 個人資料的保護" +
            "  <br />" +
            "</p>" +
            "<ul class='terms-ul-inline'>" +
            "  <li><span>3.1</span><span style='flex:1'>作為本網站的擁有者，本局保證本局工作人員均遵守所有的相關規定，你的個人資料處理會受到保密措施規範，並得到妥為保存。個人資料會保存直至該等資料無須再用於收集時所作的用途，或到政府規定的保存期限，屆時這些資料將按有關規定銷毀；</span></li>" +
            "  <li><span>3.2</span><span style='flex:1'>你有權向本局查閱及修改保存於本網站上的你的個人資料，或向接收本局之轉交並保存這些資料的其他政府部門查閱及修改保存於該局網站上的你的個人資料。</span></li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  4. 免責聲明" +
            "  <br />" +
            "</p>" +
            "<ul class='terms-ul-inline'>" +
            "  <li><span>4.1</span><span style='flex:1'>本網站已盡力確保內容準確，但並不對該等內容作出任何明示或隱含的保證及承諾，所有資料以「現狀」提供，不負任何責任。交通事務局也保留權利隨時刪除、暫時停載或編輯本網址上的各項資料而無須事先通知。交通事務局不對因為使用網站的資料而引致的任何損害或損失負任何責任或作任何賠償。</span></li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  5. 私隱條款" +
            "  <br />" +
            "</p>" +
            "<ul class='terms-ul-inline'>" +
            "  <li><span>5.1</span><span style='flex:1'>繳費者於本系統所輸入之個人資料只會用於本系統及列印在電子收據上；</span></li>" +
            "  <li><span>5.2</span><span style='flex:1'>為使使用者於本網頁所輸入的資料保密，本服務使用加密套接協議層(SSL)。</span></li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  6. 若本使用條款有任何更新，我們會用新版本取代舊版本發佈，並在文件中列明更新修訂日期，但不作另行公佈。" +
            "  <br />" +
            "</p>" +
            "<p></p>" +
            "<p>" +
            "  7. 聯絡方法" +
            "  <br />" +
            "</p>" +
            "<ul class='terms-ul-inline'>" +
            "  <li>地址：澳門馬交石炮台馬路33號地下 交通事務局（馬交石）服務專區</li>" +
            "  <li>辦公時間：星期一至星期五上午9時至下午6時(中午照常辦公)</li>" +
            "  <li>交通事務專線：(853) 8866 6363</li>" +
            "  <li>電郵：info@dsat.gov.mo</li>" +
            "</ul>",
    }
}